// حركة حلقة الجاهزية: تتحرك كالعقرب بسلاسة، لا تقفز أبداً.
export const SPEED_ALL_PASS = 1.8;
export const SPEED_PARTIAL = 0.45;
export const SPEED_DOWN = 0.9;
export const VELOCITY_EASE_MS = 150;
export const LANDING_ZONE = 0.06;
export const GREEN_EASE_MS = 120;
export const TICK_COUNT = 72;

export function createReadiness() {
  return { shown: 0, v: 0, green: 0, ready: false };
}

export function resetReadiness(s) {
  s.shown = 0; s.v = 0; s.green = 0; s.ready = false;
}

export function stepReadiness(s, passing, total, dtMs) {
  const dtc = Math.min(Math.max(dtMs, 0), 64);
  const allPass = passing >= total;
  const target = allPass ? 1 : Math.max(0, passing) / total;
  const diff = target - s.shown;
  if (Math.abs(diff) < 0.0005) {
    s.shown = target; s.v = 0;
  } else {
    const up = diff > 0;
    const speed = up ? (allPass ? SPEED_ALL_PASS : SPEED_PARTIAL) : SPEED_DOWN;
    const landing = Math.max(0.2, Math.min(1, Math.abs(diff) / LANDING_ZONE));
    const desired = (up ? 1 : -1) * speed * landing;
    s.v += (desired - s.v) * (1 - Math.exp(-dtc / VELOCITY_EASE_MS));
    let next = s.shown + (s.v * dtc) / 1000;
    if ((up && next >= target) || (!up && next <= target)) { next = target; s.v = 0; }
    s.shown = Math.min(1, Math.max(0, next));
  }
  s.ready = allPass && s.shown >= 0.999;
  s.green += ((s.ready ? 1 : 0) - s.green) * (1 - Math.exp(-dtc / GREEN_EASE_MS));
}

// 72 شرطة حول قطع ناقص (175,215) rx162 ry207 داخل viewBox 350x430، الشرطة 0 بالأعلى باتجاه عقارب الساعة.
export function buildTicks() {
  const cx = 175, cy = 215, rx = 162, ry = 207, len = 7, out = [];
  for (let k = 0; k < TICK_COUNT; k++) {
    const a = -Math.PI / 2 + (k / TICK_COUNT) * Math.PI * 2;
    const px = cx + rx * Math.cos(a), py = cy + ry * Math.sin(a);
    let nx = Math.cos(a) / rx, ny = Math.sin(a) / ry;
    const nl = Math.hypot(nx, ny); nx /= nl; ny /= nl;
    out.push({ x1: +px.toFixed(1), y1: +py.toFixed(1), x2: +(px + nx * len).toFixed(1), y2: +(py + ny * len).toFixed(1) });
  }
  return out;
}

const EMPTY = [211, 218, 227], BLUE = [42, 114, 196], GREEN = [22, 163, 106];

export function tickColor(s, k) {
  const fill = Math.max(0, Math.min(1, s.shown * TICK_COUNT - k));
  const g = s.green;
  const on0 = BLUE[0] + (GREEN[0] - BLUE[0]) * g;
  const on1 = BLUE[1] + (GREEN[1] - BLUE[1]) * g;
  const on2 = BLUE[2] + (GREEN[2] - BLUE[2]) * g;
  const r = Math.round(EMPTY[0] + (on0 - EMPTY[0]) * fill);
  const gg = Math.round(EMPTY[1] + (on1 - EMPTY[1]) * fill);
  const b = Math.round(EMPTY[2] + (on2 - EMPTY[2]) * fill);
  return `rgb(${r},${gg},${b})`;
}
